import React, { useState } from 'react'
import { Badge, Button, Card, Pagination } from 'react-bootstrap'
import './Lotes.css'
import { useApi } from 'ApiHooks'
import { useBlockUI } from 'Context/BlockUIContext'
import { useErrorModal } from 'Context/ErrorModalContext'
import ModalVistaPreviaPDF from 'Components/ModalVistaPreviaPDF'
import { Lote } from 'Interfaces/LoteBusqueda'

export interface LotesCardMobileProps {
    title: string
    variant: string
    data: any[]
    totalPaginas: number
    paginaActual: number
    obtenerLotesPaginado: (pagina: number) => Promise<void>
}
const LotesCardMobile = ({ title, variant, data, totalPaginas, paginaActual, obtenerLotesPaginado }: LotesCardMobileProps) => {

    const api = useApi()
    const { showBlock, hideBlock } = useBlockUI()
    const { showError } = useErrorModal()

    const [showModalPDF, setShowModalPDF] = useState<boolean>(false)
    const [base64Data, setBase64Data] = useState<string | null>(null)
    const [nroLotePDF, setNroLotePDF] = useState<number | null>(null)
    const [fechaLote, setFechaLote] = useState<string>('')
    const [tipoEnvioLote, setTipoEnvioLote] = useState<string>('')

    const impresionLotes = async (nrosLotes: [number]) => {
        showBlock("Generando impresión de lotes...")
        try {
            const response = await api.generarImpresionLotes(nrosLotes)
            setBase64Data(response?.formularioStringBase64)
            setShowModalPDF(true)
            hideBlock()
        } catch (error: any) {
            if (!api.isCancel(error)) {
                showError({
                    title: 'Error al cargar datos',
                    message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message?.length > 0 ? error?.response?.data?.message : 'Error desconocido del servidor',
                })
            }
        } finally {
            hideBlock()
        }
    }

    return (
        <>
            <Card className="shadow-sm border-0">
                <Card.Header className={`bg-${variant} text-white d-flex justify-content-between align-items-center`}>
                    <span className="fw-bold">{title}</span>
                    <Badge variant="light" className="text-dark">
                        {data.length}
                    </Badge>
                </Card.Header>

                <Card.Body className="p-2">
                    {data.length === 0 ? (
                        <div className="p-4 text-center text-muted">
                            <i className="bi bi-inbox fs-2 d-block mb-2"></i>
                            No hay registros para mostrar
                        </div>
                    ) : (
                        <div className="lotes-mobile-scroll">
                            {data.map((lote: Lote, index: number) => (
                                <Card key={index} className="mb-2 shadow-sm border-0" style={{ backgroundColor: 'white' }}>
                                    <Card.Body className="p-2">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <strong>ID:</strong> {lote.generadorId}
                                                <strong> - Lote:</strong> {lote.nroImpresionLote}
                                                <br />
                                                <small className="text-muted">{lote.fechaEnvio}</small>
                                            </div>

                                            <Button
                                                size="lg"
                                                variant={variant}
                                                onClick={() => {
                                                    setTipoEnvioLote(lote?.correo)
                                                    setFechaLote(lote?.fechaEnvio)
                                                    setNroLotePDF(Number(lote?.generadorId))
                                                    impresionLotes([Number(lote?.generadorId)])
                                                }}
                                            >
                                                Ver
                                            </Button>
                                        </div>

                                        <hr className="my-2" />

                                        <div className="small">
                                            <div>
                                                <strong>Correo:</strong>
                                                <Badge variant="secondary">{lote?.correo === "" ? 'BANK' : lote?.correo}</Badge>
                                            </div>
                                            <div>
                                                <strong>Domicilio:</strong> {lote.domicilioRecepcion}
                                            </div>
                                            <div>
                                                <strong>Localidad:</strong> {lote.localidadRecepcion}
                                            </div>
                                            <div>
                                                <strong>Estado:</strong> {lote.estadoDescripcion}
                                            </div>
                                            {lote.observaciones && (
                                                <div>
                                                    <strong>Obs:</strong> {lote.observaciones}
                                                </div>
                                            )}
                                        </div>


                                    </Card.Body>
                                </Card>
                            ))}
                            {totalPaginas > 1 && (
                                <Pagination className="justify-content-center mt-3">
                                    <Pagination.First
                                        disabled={paginaActual === 1}
                                        onClick={() => obtenerLotesPaginado(1)}
                                    />

                                    <Pagination.Prev
                                        disabled={paginaActual === 1}
                                        onClick={() => obtenerLotesPaginado(paginaActual - 1)}
                                    />

                                    {[...Array(totalPaginas)].map((_, i) => (
                                        <Pagination.Item
                                            key={i + 1}
                                            active={paginaActual === i + 1}
                                            onClick={() => obtenerLotesPaginado(i + 1)}
                                        >
                                            {i + 1}
                                        </Pagination.Item>
                                    ))}

                                    <Pagination.Next
                                        disabled={paginaActual === totalPaginas}
                                        onClick={() => obtenerLotesPaginado(paginaActual + 1)}
                                    />

                                    <Pagination.Last
                                        disabled={paginaActual === totalPaginas}
                                        onClick={() => obtenerLotesPaginado(totalPaginas)}
                                    />
                                </Pagination>
                            )}
                        </div>
                    )}
                </Card.Body>

            </Card>
            <ModalVistaPreviaPDF
                showModalVistaArchivo={showModalPDF}
                handleCloseModalVisualizarArchivo={() => {
                    setShowModalPDF(false)
                    setBase64Data(null)
                    obtenerLotesPaginado(1)
                }}
                base64Archivo={base64Data!}
                nombreArchivo={tipoEnvioLote === 'ANDREANI' ? `BANK_Pedido_guia_Andreani_${fechaLote}.pdf` : `BANK_Pedido_guia_${nroLotePDF}.pdf`}
                nroLotePDF={nroLotePDF!}


            />
        </>
    )
}

export default LotesCardMobile
